/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AvatarPersona as AvatarPersona,
  rec_CalendarioFecha as CalendarioFecha,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Tr as Tr,
  rec__S as _S,
  rec_dS as dS,
  rec_gS as gS,
  rec_kx as kx,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function SelectorFecha({
  value: e,
  onChange: t,
  min: n,
  max: r,
  disabled: i = !1,
  placeholder: a = `Elegí una fecha`,
  className: o = ``,
  id: s,
}) {
  let [c, l] = (0, React.useState)(!1),
    u = gS(e),
    [f, p] = (0, React.useState)(() => u ?? new Date()),
    m = (0, React.useRef)(null);
  ((0, React.useEffect)(() => {
    c && u && p(u);
  }, [c]),
    kx(
      c,
      m,
      (0, React.useCallback)(() => l(!1), []),
    ));
  let h = dS(new Date()),
    g = (e) => (n && e < n) || (r && e > r);
  function _(e) {
    g(e) || (t(e), l(!1));
  }
  return (
    <div
      className={`relative ${o}`}
      ref={m}
      children={[
        <button
          type={`button`}
          id={s}
          disabled={i}
          aria-label={e ? `Fecha: ${_S(e)}. Cambiar` : a}
          onClick={() => l((e) => !e)}
          className={`flex w-full items-center justify-between gap-2 rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) disabled:cursor-not-allowed disabled:opacity-60`}
          children={[
            <span
              className={`truncate ${e ? `text-(--text-h)` : `text-(--text)/70`}`}
              children={e ? _S(e) : a}
            />,
            <span
              className={`flex shrink-0 items-center gap-1`}
              children={[
                e && !i && (
                  <span
                    role={`button`}
                    tabIndex={0}
                    aria-label={`Quitar fecha`}
                    onClick={(e) => {
                      (e.stopPropagation(), t(``));
                    }}
                    onKeyDown={(e) => {
                      (e.key === `Enter` || e.key === ` `) &&
                        (e.preventDefault(), e.stopPropagation(), t(``));
                    }}
                    className={`rounded p-0.5 text-(--text) hover:text-(--error)`}
                    children={(0, JSXRuntime.jsx)(ra, {
                      className: `h-3.5 w-3.5`,
                    })}
                  />
                ),
                <Tr className={`h-4 w-4 text-(--text)`} />,
              ]}
            />,
          ]}
        />,
        c && (
          <AvatarPersona
            anclaRef={m}
            className={`min-w-72 rounded-2xl border border-(--border) bg-(--bg) p-3 shadow-2xl`}
            children={[
              <CalendarioFecha
                mesRef={f}
                setMesRef={p}
                value={e}
                onElegir={_}
                fueraDeRango={g}
              />,
              <div
                className={`mt-2 flex items-center justify-between border-t border-(--border) pt-2`}
                children={[
                  <button
                    type={`button`}
                    onClick={() => _(h)}
                    disabled={g(h)}
                    className={`text-xs font-medium text-(--accent) hover:underline disabled:opacity-40 disabled:hover:no-underline`}
                    children={`Hoy`}
                  />,
                  e && (
                    <button
                      type={`button`}
                      onClick={() => {
                        (t(``), l(!1));
                      }}
                      className={`text-xs text-(--text) hover:text-(--text-h)`}
                      children={`Quitar`}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
